module.exports = __webpack_public_path__ + "img/Jump Casting57.b6822f64.jpg";